import { render } from "./SchemaImage.vue?vue&type=template&id=747e0116&scoped=true&ts=true"
import script from "./SchemaImage.vue?vue&type=script&lang=ts"
export * from "./SchemaImage.vue?vue&type=script&lang=ts"

import "./SchemaImage.vue?vue&type=style&index=0&id=747e0116&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747e0116"]])

export default __exports__